import { useStore } from '@stores';
import { Form } from 'antd';
import { observer } from 'mobx-react';
import React, { useCallback, useEffect, useState } from 'react';
import Presentation from './GarageVatRegistration.presentation';

interface IProps {
  vatNumber?: string;
}

export const GarageVatRegistration: React.FC<IProps> = observer(({ vatNumber }) => {
  const { tenantProfileStore, sessionStore } = useStore();
  const [form] = Form.useForm();
  const [vatNo, setVatNo] = useState<string>();

  useEffect(() => {
    setVatNo(vatNumber);
    form.setFieldsValue({ vatNumber });
  }, [vatNumber, form]);

  const handleUpdate = useCallback(
    async (values: any) => {
      const response = await tenantProfileStore.updateVatNumber({ vatNumber: values.vatNumber.trim() });
      if (response) {
        await sessionStore.getCurrentLoginInformations();
        setVatNo(response);
        form.setFieldsValue({ vatNumber: response });
      } else {
        form.setFieldsValue({ vatNumber: response });
      }
    },
    [tenantProfileStore, sessionStore, form]
  );

  const handleDelete = useCallback(async () => {
    const result = await tenantProfileStore.updateVatNumber({ vatNumber: undefined });
    if (result) {
      setVatNo(undefined);
      form.setFieldsValue({ vatNumber: undefined });
    } else {
      form.setFieldsValue({ vatNumber: vatNo });
    }
  }, [tenantProfileStore, form, vatNo]);

  return (
    <Presentation
      form={form}
      vatNumber={vatNo}
      handleUpdate={handleUpdate}
      handleDelete={handleDelete}
    />
  );
});
